import { APP } from 'actions/appActions';
import { SESSION } from 'actions/sessionActions';
import { stateConfig } from 'utils/reducerUtils';
import { FORM, generateState } from 'utils/formUtils';
import { REST } from 'utils/reqUtils';
import store from 'store';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ Request } = ssCommonUtils,
{ REGISTRATION, LOGIN, REQUEST } = APP,
{ login, registration, recovery, request } = stateConfig,
{ NONE, PENDING, SUCCESS, FAILURE } = REST.STATUS;

const init = {
    portalType: 'CANDIDATE',
    login: {
        login: generateState(login.login.candidate),
        forgotten: generateState(login.forgotten.candidate),
        changeEmail: generateState(login.changeEmail.candidate)
    },
    registration: {
        fsdoLocations: [],
        captchaBase64: '',
        personal: generateState(registration.personal.candidate),
        passport: generateState(registration.passport.candidate),
        email: generateState(registration.email.candidate),
        security: generateState(registration.security.candidate),
        signature: generateState(registration.signature.candidate),
        submit: generateState(registration.submit.candidate)
    },
    recovery: {
        fsdoLocations: [],
        captchaBase64: '',
        personal: generateState(recovery.personal.candidate),
        passport: generateState(recovery.passport.candidate),
        email: generateState(recovery.email.candidate),
        signature: generateState(recovery.signature.candidate),
        submit: generateState(recovery.submit.candidate)
    },
    provRegistration: {
        provider: generateState(registration.personal.provider),
    },
    request: {
        registration: request.registration,
        recovery: request.recovery,
        home: {
            login: request.home.login,
            forgot: request.home.forgot,
            change: request.home.change,
            reset: request.home.reset,
        },
        captcha: request.captcha,
        captchaValidation: request.captchaValidation,
        check: request.check,
        fsdoLocations: new Request
    }
};

export default (state=init, action) => {
    const requestUpdater = (format, type) => {
        let
        path = type.split('.'),
        getStatus = function(format) {
            switch(format) {
                case NONE: return NONE;
                case PENDING: return PENDING;
                case SUCCESS: return SUCCESS;
                case FAILURE: return FAILURE;
                default: return NONE;
            }
        }

        // This is really just the number of levels that exist.
        // If there is a general condition for each type of level
        // this can then generalize state updates.
        switch(path.length) {
            case 1:
                return {...state,
                    [path[0]]: {...state[path[0]],
                        status: getStatus(format),
                        error: action.error ? action.payload : false,
                        code: action.meta ? action.meta.code : null
                    }
                }
            case 2:
                return {...state,
                    [path[0]]: {...state[path[0]],
                        [path[1]]: {...state[path[0]][path[1]],
                            status: getStatus(format),
                            error: action.error ? action.payload : false,
                            code: (type == 'request.registration' && format == NONE) ? null : action.meta ? action.meta.code : null
                        }
                    }
                }
            case 3:
                return {...state,
                    [path[0]]: {...state[path[0]],
                        [path[1]]: {...state[path[0]][path[1]],
                            [path[2]]: {...state[path[0]][path[1]][path[2]],
                                status: getStatus(format),
                                error: action.error ? action.payload : false,
                                code: action.meta ? action.meta.code : null
                            }
                        }
                    }
                }
        }
    };

    switch(action.type) {
        case APP.SET_PORTAL_TYPE:
            const { portalType } = action.payload;
            return {...state, portalType: portalType };

        case APP.GET_FSDO_LOCATIONS_PENDING:
            return {...state, request: {...state.request,
                fsdoLocations: {...state.request.fsdoLocations, status: 'pending' }
            }};

        case APP.GET_FSDO_LOCATIONS_SUCCESS:
            return {...state,
                registration: {...state.registration, fsdoLocations: action.payload },
                request: {...state.request,
                    fsdoLocations: {...state.request.fsdoLocations, status: 'success' }
                }
            };

        case APP.GET_FSDO_LOCATIONS_FAILURE:
            return {...state, request: {...state.request,
                fsdoLocations: {...state.request.fsdoLocations, status: 'failure' }
            }};
    }

    switch(action.type) {
        // Update the check rest state indicator.
        case REQUEST.CHECK:
            var
            { data } = action.meta,
            sr = data.ref.split('.'),
            newState = {...state};

            switch(action.meta.code) {
                case 0:
                    newState[sr[0]][sr[1]][sr[2]].form = {...newState[sr[0]][sr[1]][sr[2]].form,
                        help: data.help.pending,
                        validateStatus: 'validating'
                    }
                    return newState;
                case 200:
                    newState[sr[0]][sr[1]][sr[2]] = {...newState[sr[0]][sr[1]][sr[2]],
                        valid: false,
                        form: {...newState[sr[0]][sr[1]][sr[2]].form,
                            help: data.help._200,
                            validateStatus: 'warning'
                        }
                    };
                    return newState;
                case 400: // Bad request.
                    newState[sr[0]][sr[1]][sr[2]].form = {...newState[sr[0]][sr[1]][sr[2]].form,
                        help: 'Error. Call help desk.',
                        validateStatus: 'warning'
                    }
                    return newState;
                case 404: // Does not exist.
                    newState[sr[0]][sr[1]][sr[2]].form = {...newState[sr[0]][sr[1]][sr[2]].form,
                        help: data.help._404,
                        validateStatus: 'success'
                    }
                    return newState;
                case 500: // Internal error.
                    newState[sr[0]][sr[1]][sr[2]] = {...newState[sr[0]][sr[1]][sr[2]],
                        valid: false,
                        form: {...newState[sr[0]][sr[1]][sr[2]].form,
                            help: 'Error. Call help desk.',
                            validateStatus: 'error'
                        }
                    };
                    return newState;
            }
            return {...state};

        case REQUEST.CHECK_RESET:
            return {...state, request: {...state.request, check: request.check }};
        case REQUEST.CHECK_PENDING:
            return {...state,
                request: {...state.request,
                    check: {...request.check,
                        status: PENDING
                    }
                }
            };
        case REQUEST.CHECK_SUCCESS:
            return {...state,
                request: {...state.request,
                    check: {...request.check,
                        status: SUCCESS
                    }
                }
            };
        case REQUEST.CHECK_FAILURE:
            return {...state,
                request: {...state.request,
                    check: {...request.check,
                        status: FAILURE
                    }
                }
            };

        ///////////////////////////////////////////////////////////////////////////////////////////////////
        // Update the registration rest state indicator.
        case REQUEST.REGISTRATION.RESET: return requestUpdater(NONE, 'request.registration');
        case REQUEST.REGISTRATION.PENDING: return requestUpdater(PENDING, 'request.registration');
        case REQUEST.REGISTRATION.SUCCESS: return requestUpdater(SUCCESS, 'request.registration');
        case REQUEST.REGISTRATION.FAILURE: return requestUpdater(FAILURE, 'request.registration');

        ///////////////////////////////////////////////////////////////////////////////////////////////////
        // State status contol for the home pages 'login'.
        case REQUEST.HOME.LOGIN.RESET: return requestUpdater(NONE, 'request.home.login')
        case REQUEST.HOME.LOGIN.PENDING: return requestUpdater(PENDING, 'request.home.login');
        case REQUEST.HOME.LOGIN.SUCCESS: return requestUpdater(SUCCESS, 'request.home.login');
        case REQUEST.HOME.LOGIN.FAILURE: return requestUpdater(FAILURE, 'request.home.login');

        ///////////////////////////////////////////////////////////////////////////////////////////////////
        // State status contol for the home pages 'forgot password'.
        case REQUEST.HOME.FORGOT.RESET: return requestUpdater(NONE, 'request.home.forgot');
        case REQUEST.HOME.FORGOT.PENDING: return requestUpdater(PENDING, 'request.home.forgot');
        case REQUEST.HOME.FORGOT.SUCCESS: return requestUpdater(SUCCESS, 'request.home.forgot');
        case REQUEST.HOME.FORGOT.FAILURE: return requestUpdater(FAILURE, 'request.home.forgot');

        ///////////////////////////////////////////////////////////////////////////////////////////////////
        // State status contol for the home pages 'change email'.
        case REQUEST.HOME.CHANGE.RESET: return requestUpdater(NONE, 'request.home.change');
        case REQUEST.HOME.CHANGE.PENDING: return requestUpdater(PENDING, 'request.home.change');
        case REQUEST.HOME.CHANGE.SUCCESS: return requestUpdater(SUCCESS, 'request.home.change');
        case REQUEST.HOME.CHANGE.FAILURE: return requestUpdater(FAILURE, 'request.home.change');

        ///////////////////////////////////////////////////////////////////////////////////////////////////
        // State status contol for the home pages 'password reset'.
        case REQUEST.HOME.RESET.RESET: return requestUpdater(NONE, 'request.home.change');
        case REQUEST.HOME.RESET.PENDING: return requestUpdater(PENDING, 'request.home.change');
        case REQUEST.HOME.RESET.SUCCESS: return requestUpdater(SUCCESS, 'request.home.change');
        case REQUEST.HOME.RESET.FAILURE: return requestUpdater(FAILURE, 'request.home.change');

        ///////////////////////////////////////////////////////////////////////////////////////////////////
        // Update the captcha indicator for loading a captcha.
        case REQUEST.CAPTCHA.RESET: return requestUpdater(NONE, 'request.captcha');
        case REQUEST.CAPTCHA.PENDING: return requestUpdater(PENDING, 'request.captcha');
        case REQUEST.CAPTCHA.SUCCESS: return requestUpdater(SUCCESS, 'request.captcha');
        case REQUEST.CAPTCHA.FAILURE: return requestUpdater(FAILURE, 'request.captcha');

        ///////////////////////////////////////////////////////////////////////////////////////////////////
        // Update the captcha indicator for validating a captcha.
        case REQUEST.CAPTCHA.VALIDATION.RESET: return requestUpdater(NONE, 'request.captchaValidation');
        case REQUEST.CAPTCHA.VALIDATION.PENDING: return requestUpdater(PENDING, 'request.captchaValidation');
        case REQUEST.CAPTCHA.VALIDATION.SUCCESS: return requestUpdater(SUCCESS, 'request.captchaValidation');
        case REQUEST.CAPTCHA.VALIDATION.FAILURE: return requestUpdater(FAILURE, 'request.captchaValidation');

        // Update the various parts of the login modal.
        case LOGIN.SET_LOGIN:
            return {...state, login: {...state.login, login: action.payload } };
        case LOGIN.SET_FORGOTTEN:
            return {...state, login: {...state.login, forgotten: action.payload } };
        case LOGIN.SET_CHANGE_EMAIL:
            return {...state, login: {...state.login, changeEmail: action.payload } };

        // Update the registration data in the Redux state.
        case REGISTRATION.SET_PERSONAL:
            return {...state, registration: {...state.registration, personal: action.payload } };
        case REGISTRATION.SET_PASSPORT:
            return {...state, registration: {...state.registration, passport: action.payload } };
        case REGISTRATION.SET_EMAIL:
            return {...state, registration: {...state.registration, email: action.payload } };
        case REGISTRATION.SET_SECURITY:
            return {...state, registration: {...state.registration, security: action.payload } };
        case REGISTRATION.SET_SIGNATURE:
            return {...state, registration: {...state.registration, signature: action.payload } };
        case REGISTRATION.SET_SUBMIT:
            return {...state, registration: {...state.registration, submit: action.payload } };
        case REGISTRATION.SET_CAPTCHA_BASE64:
            return {...state, registration: {...state.registration, captchaBase64: action.payload } };
        case REGISTRATION.SET_PROVIDER:
            return {...state, registration: {...state.provider, provider: action.payload } };

        default: return {...state};
    }
}
